var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-copy",
    "data-name": "Icon feather-copy",
    transform: "translate(-1.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2397",
    "data-name": "Trac\\xE9 2397",
    d: "M16.5,13.5H30a3,3,0,0,1,3,3V30a3,3,0,0,1-3,3H16.5a3,3,0,0,1-3-3V16.5A3,3,0,0,1,16.5,13.5Z",
    fill: "none",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2398",
    "data-name": "Trac\\xE9 2398",
    d: "M7.5,22.5H6a3,3,0,0,1-3-3V6A3,3,0,0,1,6,3H19.5a3,3,0,0,1,3,3V7.5",
    fill: "none",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.4a43f966aebc6e3c3d4c5fabe1e4c0e6.svg";
export { ForwardRef as ReactComponent };